import moment from "moment";
import React, { useEffect, useState } from "react";

export function TwoocaReceiptDetailModal(props) {
  const [total, setTotal] = useState(0);
  const [subTotal, setSubTotal] = useState(0);
  const [tax8PercentTotal, setTax8PercentTotal] = useState(0);
  const [tax10PercentTotal, setTax10PercentTotal] = useState(0);

  useEffect(() => {
    sumAllTotal(props.receiptChoose?.receiptDetails);
  }, [props.receiptChoose]);

  function sumAllTotal(arrayNumber) {
    // Calulate taxMount, total, and subtotal of all items that were not included tax
    const sumNotTaxed = withAllItemsNotTaxed(arrayNumber);
    let taxAmount8NotTaxed = 0;
    let taxAmount10NotTaxed = 0;
    let sumSubTotalNotTaxed = 0;
    let sumTotalNotTaxed = 0;
    if (sumNotTaxed) {
      taxAmount8NotTaxed = Math.floor(sumNotTaxed.sumItemTax8 * 0.08);
      taxAmount10NotTaxed = Math.floor(sumNotTaxed.sumItemTax10 * 0.1);
      sumSubTotalNotTaxed = sumNotTaxed.sumSubTotal;

      sumTotalNotTaxed =
        sumSubTotalNotTaxed + taxAmount8NotTaxed + taxAmount10NotTaxed;
    }

    // Calulate taxMount, total, and subtotal of all items that were included tax
    const sumTaxed = withAllItemsTaxed(arrayNumber);
    let taxAmount8Taxed = 0;
    let taxAmount10Taxed = 0;
    let sumSubTotalTaxed = 0;
    let sumTotalTaxed = 0;
    if (sumTaxed) {
      // Công thức ban đầu là Math.floor(((sumTaxed.sumItemTax8) / 1.08) * 0.08);
      // nhưng do phép tính "sumTaxed.sumItemTax8) / 1.08" bị lỗi phép chia với phân số (ví dụ 1080/1.08 đúng ra phải bằng 1000 nhưng máy tính tính ra thành 999.999999999)
      // nên để tránh lỗi trên thì sẽ nhân cả tử và mẫu vs 100 để k phải làm phép tính chia cho số thập phân. Sửa tương tự vs taxAmount10Taxed
      // See more: https://stackoverflow.com/questions/15383376/javascript-division-giving-wrong-answer
      taxAmount8Taxed = Math.floor(((sumTaxed.sumItemTax8 * 100) / 108) * 0.08);
      taxAmount10Taxed = Math.floor(((sumTaxed.sumItemTax10 * 10) / 11) * 0.1);
      sumTotalTaxed = sumTaxed.sumTotal;

      sumSubTotalTaxed = sumTotalTaxed - taxAmount8Taxed - taxAmount10Taxed;
    }

    setTotal(sumTotalNotTaxed + sumTotalTaxed);
    setSubTotal(sumSubTotalNotTaxed + sumSubTotalTaxed);
    setTax8PercentTotal(taxAmount8NotTaxed + taxAmount8Taxed);
    setTax10PercentTotal(taxAmount10NotTaxed + taxAmount10Taxed);
  }

  // With all items that have taxed = true
  function withAllItemsTaxed(arrayNumber) {
    let sumTotal = 0;
    let sumItemTax8 = 0;
    let sumItemTax10 = 0;

    if (arrayNumber && arrayNumber.length > 0) {
      arrayNumber.map((row) => {
        if (row.taxed === true) {
          // Total of items that included tax
          sumTotal += row.amount ? row.amount : 0;

          if (row.taxRate === 0.08) {
            // Sum price of items having tax = 8%
            sumItemTax8 += row.amount ? row.amount : 0;
          }

          if (row.taxRate === 0.1) {
            // Sum price of items having tax = 10%
            sumItemTax10 += row.amount ? row.amount : 0;
          }
        }
      });
    }
    return { sumTotal: sumTotal, sumItemTax8, sumItemTax10 };
  }

  // With items that have taxed = false
  function withAllItemsNotTaxed(arrayNumber) {
    let sumSubTotal = 0;
    let sumItemTax8 = 0;
    let sumItemTax10 = 0;

    if (arrayNumber && arrayNumber.length > 0) {
      arrayNumber.map((row) => {
        if (row.taxed === false) {
          // Sum of all subtotal
          sumSubTotal += row.amount ? row.amount : 0;

          // Sum price of items having tax = 8%
          if (row.taxRate === 0.08) {
            sumItemTax8 += row.amount ? row.amount : 0;
          }

          // Sum of all items have tax = 10%
          if (row.taxRate === 0.1) {
            sumItemTax10 += row.amount ? row.amount : 0;
          }
        }
      });
    }
    return {
      sumSubTotal: sumSubTotal,
      sumItemTax8: sumItemTax8,
      sumItemTax10: sumItemTax10,
    };
  }

  return (
    <div
      className={
        props.showing
          ? "custom-modal-container group-special-gochi-kid-modal gochi-kid-preview-image-receipt-modal gochi-kid-receipt-result-modal twooca-receipt-detail show-modal"
          : "custom-modal-container group-special-gochi-kid-modal gochi-kid-preview-image-receipt-modal gochi-kid-receipt-result-modal twooca-receipt-detail"
      }
      size="sm"
    >
      <div
        className={
          props.showing
            ? "modal modal-action modal-dialog is-show history-modal"
            : "modal modal-action modal-dialog history-modal"
        }
      >
        <div className="modal-header-history">
          <button
            className="modal-btn modal-btn-close"
            id="modalClose"
            onClick={() => props.onClose()}
            type="button"
          >
            <svg className="icon">
              <title>閉じる</title>
              <use xlinkHref="/assets/img/common/icon.svg#times" />
            </svg>
          </button>
        </div>
        <div className="title-modal title-modal-charge">
          <div className="title required-dot">
            <div className="dot-red"></div>
            レシート詳細
          </div>
        </div>
        <div className={`modal-body`}>
          <div className="preview-image-box">
            <img
              src={
                props.receiptImageBase64?.imageBase64 ||
                props.receiptImageBase64?.image ||
                props.receiptChoose?.receiptImage
              }
              width="100%"
              height="auto"
              className="image-receipt"
            />
          </div>
          <div className="receipt-detail">
            <div className="receipt-detail-row">
              <div className="title">日付</div>
              <div className="date">
                {props.receiptChoose?.receiptDate && (
                  <>
                    <span className="date-text">
                      {moment(props.receiptChoose?.receiptDate).year()}
                    </span>
                    <span>年</span>
                    <span className="date-text">
                      {String(
                        moment(props.receiptChoose?.receiptDate).month() + 1
                      ).padStart(2, "0")}
                    </span>
                    <span>月</span>
                    <span className="date-text">
                      {String(
                        moment(props.receiptChoose?.receiptDate).date()
                      ).padStart(2, "0")}
                    </span>
                    <span>日</span>
                  </>
                )}
              </div>
            </div>
            <div className="receipt-detail-row">
              <div className="title">店舗</div>
              <div className="shop-text">
                {props.receiptChoose?.receiptShopName
                  ? `${props.receiptChoose?.receiptShopName} `
                  : ""}
                {props.receiptChoose?.receiptBranch
                  ? props.receiptChoose?.receiptBranch
                  : ""}
              </div>
            </div>
            <div className="receipt-detail-row">
              <div className="title">合計</div>
              <div className="text">
                {total ? total.toLocaleString() : 0}
                <span className="yen">円</span>
              </div>
            </div>
            <div className="receipt-detail-row">
              <div className="title">小計</div>
              <div className="text">
                {subTotal && subTotal.toLocaleString()}
                <span className="yen">円</span>
              </div>
            </div>
            <div className="receipt-detail-row">
              <div className="title">消費税(8%)</div>
              <div className="text">
                {tax8PercentTotal && tax8PercentTotal.toLocaleString()}
                <span className="yen">円</span>
              </div>
            </div>
            <div className="receipt-detail-row">
              <div className="title">消費税(10%)</div>
              <div className="text">
                {tax10PercentTotal && tax10PercentTotal.toLocaleString()}
                <span className="yen">円</span>
              </div>
            </div>
          </div>
          <div className="receipt-list-item">
            <div className="title">品目</div>
            <table className="receipt-table">
              <tbody>
                {props.receiptChoose?.receiptDetails &&
                  props.receiptChoose?.receiptDetails.map((row, index) => {
                    return (
                      <tr key={row.id}>
                        <td className="text-item">{row.name}</td>
                        <td className="row-warning">
                          {row.shopFoodFlag === 0 && (
                            <i className="warning-icon" />
                          )}
                        </td>
                        <td>
                          <div className="price-box">
                            <div className="value-price-box">
                              <div>{row.amount.toLocaleString()}</div>
                              <div>{row.taxRate * 100}%</div>
                            </div>
                            <div className="unit-price-box">
                              <div className="yen">円</div>
                              <div className="tax-note">
                                {row.taxRate === 0
                                  ? "非抜"
                                  : row.taxed
                                  ? "税込"
                                  : "税抜"}
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>
          <div className="modal-footer">
            <button
              onClick={() => props.onClose()}
              className={"btn btn-outline-rect btn-text"}
            >
              前の画面に戻る
            </button>
          </div>
        </div>
      </div>
      <div onClick={() => props.onClose()} className="back-drop" />
    </div>
  );
}
